const FinBankCreditScoreResultI18n = {
  topbar: {
    contractScore: 'Contratar Sankhya Score',
    updateQuery: 'Actualizar consulta',
    downloadReport: 'Descargar Informe',
    downloadReportLoading: 'Generando informe...',
    downloadReportError: 'No se pudo generar el informe. Inténtelo de nuevo o póngase en contacto con soporte.',
    consultationHistory: 'Historial de consultas',
  },
  consultationHistory: {
    title: 'Historial de consultas',
    subtitle: 'Últimas 10 consultas realizadas',
    scoreLabel: 'Score: {{value}}',
    loadMore: 'Ver más consultas',
    alertsUnavailable: 'Alertas y recomendaciones disponibles solo en la consulta actual.',
    indicatorsUnavailable: 'El historial de indicadores operativos no está disponible para esta consulta.',
  },
  unavailable: {
    badge: 'No disponible',
  },
  panel: {
    creditScore: 'Score de Crédito',
    scoreUnavailableSubtitle: 'Información no disponible',
    riskAnalysis: 'Análisis de riesgo del negocio',
    creditLimit: 'Límite de crédito',
    creditLimitForPj: 'Límite de crédito para persona jurídica',
    creditLimitForPf: 'Límite de crédito para persona física',
    creditLimitSubtitle: 'Sugerido y disponible',
    creditLimitSubtitlePf: 'Sugerido',
    scoreEvolution: 'Evolución del Score (Hasta últimas 10 consultas)',
    appointmentsSummary: 'Resumen de apuntes',
    lastUpdatedAt: 'Última actualización: {{date}}',
  },
  alerts: {
    sectionTitle: 'Alertas y recomendaciones',
    latePayment: 'Las 3 últimas facturas se pagaron con retraso.',
    inactiveCustomer: 'Cliente sin compras en los últimos 60 días.',
    increasingDelinquency: 'La morosidad aumentó en los 2 últimos meses cerrados.',
    creditLimitNearMax: 'Límite cercano al máximo. Utilización en {{percent}}% del límite aprobado.',
  },
  gauge: {
    scoreAriaLabel: 'Score {{score}} de {{scoreMax}}',
    of: 'de {{scoreMax}}',
    probabilityTitle: 'Probabilidad de incumplimiento',
    riskLabel: {
      LOW: 'Riesgo bajo',
      MEDIUM: 'Riesgo medio',
      HIGH: 'Riesgo alto',
    },
    scoreUnavailableTitle: 'Score no disponible',
    scoreUnavailableDescription: 'Esta consulta está bajo restricción judicial, por lo que no es posible mostrar los datos de score en este momento.',
  },
  risk: {
    cautionLabel: 'Nivel de cautela indicado para esta negociación',
    evaluateWithCaution: 'Evaluar con cautela.',
    suggestionTooltip: 'Esta sugerencia no sustituye el análisis de toda la información; la decisión y la responsabilidad corresponden al acreedor.',
  },
  riskAnalysis: {
    label: {
      PF: {
        LOW: 'Aprobar',
        HIGH: 'Rechazar',
      },
      PJ: {
        LOW: 'Perfil indicado',
        MEDIUM: 'Perfil medio',
        HIGH: 'Perfil riesgoso',
      },
    },
    description: {
      PF: {
        LOW: 'Presenta baja morosidad, buen comportamiento de pago, sin protestos, demandas civiles ni deudas.',
        HIGH: 'Perfil con score bajo, alta probabilidad de incumplimiento o deudas abiertas. Requiere un análisis detallado.',
      },
      PJ: {
        LOW: 'Las empresas con este perfil tienen un bajo historial de morosidad y buena capacidad de pago.',
        MEDIUM: 'Las empresas con este perfil pueden presentar deudas abiertas y score reducido, pero actualmente tienen buena capacidad de pago.',
        HIGH: 'Las empresas con este perfil presentan alto riesgo de incumplimiento y exigen cautela en la negociación.',
      },
    },
    personType: {
      PF: 'Persona física',
      PJ: 'Persona jurídica',
    },
    unavailable: {
      label: 'No disponible',
      description: 'Análisis de riesgo de negocio no disponible.',
    },
  },
  probability: {
    label: {
      LOW: 'Baja',
      MEDIUM: 'Media',
      HIGH: 'Alta',
    },
    description: {
      PF: 'Es probable que el {{value}}% de las personas con el mismo comportamiento paguen sus cuentas en los próximos 6 meses.',
      PJ: 'De cada 1000 empresas clasificadas en esta clase de score, es probable que en promedio {{value}} presente deudas en el mercado en los próximos 12 meses.',
    },
    unavailable: {
      noRelevantInfo: 'No posee información relevante para el cálculo del score.',
      notClassified: 'Empresa no clasificada, pues el modelo no se aplica a este perfil de empresa.',
      scoreUnavailable: 'Score no disponible.',
    },
  },
  limit: {
    suggestedTotal: 'Total sugerido',
    suggestedTotalPf: 'Valor máximo por cuota',
    usagePercent: '{{percent}}% utilizado',
    usageAriaLabel: 'Límite utilizado {{percent}}%',
    available: 'Disponible',
    used: 'Utilizado',
    tooltips: {
      suggestedTotal: 'Valor de crédito sugerido según el análisis de datos de mercado (bureaus).',
      available: 'Valor aún disponible para uso, considerando el total sugerido menos el valor ya utilizado.',
      used: 'Suma de los valores ya comprometidos, considerando títulos de "ingresos" abiertos vinculados al socio en el ERP.',
    },
  },
  metrics: {
    tooltips: {
      averageTicket: 'Valor promedio de las ventas realizadas por el socio en el ERP',
      defaultRate: 'Porcentaje de valores en mora en relación con el total por cobrar del socio en el ERP',
      averageSalesPerMonth: 'Cantidad promedio de ventas mensuales del socio con base en su historial en el ERP.',
      averageReceiptTerm: 'Tiempo promedio de cobro del socio en el ERP',
    },
  },
  chart: {
    seriesName: 'Score',
    emptyMessage: 'Historial insuficiente para trazar la evolución del score.',
  },
  metricCards: {
    averageTicket: {
      label: 'Ticket promedio',
      labelPF: 'Valor promedio de las cuotas',
      helper: 'Últimos 6 meses',
    },
    delinquencyRate: {
      label: 'Morosidad',
      helper: 'Últimos 6 meses',
    },
    averageMonthlySales: {
      label: 'Promedio de ventas por mes',
      helper: 'Últimos 6 meses',
    },
    averageDaysToCollect: {
      label: 'Plazo promedio de cobro',
      helper: 'Últimos 6 meses',
      value: '{{days}} días',
    },
  },
  appointments: {
    status: {
      healthy: 'Saludable',
      attention: 'Atención',
    },
    debts: {
      title: 'Deudas / Restricciones',
      latestDateLabel: 'Fecha de la deuda más reciente',
      totalCountLabel: 'Cantidad total de deudas',
      totalValueLabel: 'Valor total de las deudas',
      emptyMessage: 'Ninguna deuda encontrada',
      detail: {
        title: 'Deudas y Restricciones',
        fields: {
          creditor: 'Nombre del acreedor',
          amount: 'Valor',
          date: 'Fecha',
          contract: 'Número del contrato',
          location: 'Local',
          classification: 'Tipo de clasificación',
        },
      },
    },
    civilActions: {
      title: 'Demandas Civiles',
      latestDateLabel: 'Fecha de la acción más reciente',
      totalCountLabel: 'Total de acciones',
      emptyMessage: 'Ninguna acción encontrada',
      detail: {
        title: 'Demandas Civiles',
        subtitle: 'Hasta {{count}} más recientes',
        fields: {
          plaintiff: 'Autor',
          amount: 'Valor',
          action: 'Acción',
          date: 'Fecha',
          case: 'Proceso',
          location: 'Local',
        },
      },
    },
    protests: {
      title: 'Protestos',
      latestDateLabel: 'Fecha del protesto más reciente',
      totalCountLabel: 'Cantidad total de protestos',
      totalValueLabel: 'Valor total de protestos',
      emptyMessage: 'Ningún protesto encontrado',
      detail: {
        title: 'Protestos',
        subtitle: 'Hasta {{count}} más recientes',
        fields: {
          date: 'Fecha',
          amount: 'Valor',
          notary: 'Notaría',
          city: 'Ciudad',
          state: 'Estado',
        },
      },
    },
  },
  details: {
    pageIndicator: '{{current}} de {{total}}',
    emptyMessage: 'No se encontraron registros',
    restrictionMessage: 'Esta consulta está bajo restricción judicial, por lo que no es posible mostrar los datos en este momento.',
  },
};

export default FinBankCreditScoreResultI18n;
